import { AccessoryOperation } from './AccessoryOperation';
import { FontOperation } from './FontOperation';
import { PieceOperation } from './PieceOperation';
import { SymbolOperation } from './SymbolOperation';
import { SymbolCollectionOperation } from './SymbolCollectionOperation';
import { DeliveryUnitOperation } from './DeliveryUnitOperation';
import { MerchantOperation } from './MerchantOperation';
import { PlatformSaleCatalogOperation } from './PlatformSaleCatalogOperation';
import { DeliveryUnitSaleCatalogOperation } from './DeliveryUnitSaleCatalogOperation';
import { SecurityOperation } from './SecurityOperation';
import { PartyOperation } from './PartyOperation';
import { MerchantChannelCatalogOperation } from './MerchantChannelCatalogOperation';
import { JobOperation } from './JobOperation';
import { WebshopOperation } from './WebshopOperation';
import { PlatformOperation } from './PlatformOperation';
import { RequestOperation } from './RequestOperation';

export const GQLOperationBuilder = {
  accessory: new AccessoryOperation(),
  piece: new PieceOperation(),
  font: new FontOperation(),
  symbol: new SymbolOperation(),
  symbolCollection: new SymbolCollectionOperation(),

  deliveryUnit: new DeliveryUnitOperation(),
  merchant: new MerchantOperation(),
  merchantChannelCatalog: new MerchantChannelCatalogOperation(),

  deliveryUnitSaleCatalog: new DeliveryUnitSaleCatalogOperation(),

  platform: new PlatformOperation(),
  platformSaleCatalog: new PlatformSaleCatalogOperation(),
  security: new SecurityOperation(),
  party: new PartyOperation(),
  job: new JobOperation(),
  webshop: new WebshopOperation(),
  request: new RequestOperation()
};
